export const DEFAULT_ITEMS_PER_PAGE = 20;

export const DEFAULT_ITEMS_PER_PAGE_OPTIONS = [20, 40, 60];

export function getTotalPages(
  totalItems: number,
  itemsPerPage = DEFAULT_ITEMS_PER_PAGE,
): number {
  return Math.ceil(totalItems / itemsPerPage);
}

const MAX_VISIBLE_ITEMS = 7;

function range(start: number, end: number): number[] {
  return Array.from({ length: end - start }, (_, i) => start + i);
}

export function getVisiblePages(
  page: number,
  totalPages: number,
): Array<number | string> {
  if (totalPages <= MAX_VISIBLE_ITEMS) return range(1, totalPages + 1);

  if (totalPages - page <= 3) {
    return [1, '...', ...range(totalPages - 4, totalPages + 1)];
  }

  if (page <= 4) {
    return [...range(1, 6), '...', totalPages];
  }

  if (page > 4 && page < totalPages - 3) {
    return [1, '...', page - 1, page, page + 1, '...', totalPages];
  }

  return [];
}
